// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__P9mkQ","root__isInTopBar":"Tabs_root__isInTopBar__2zvgq","tab":"Tabs_tab__1XZ6E","tab__isActive":"Tabs_tab__isActive__BxIMr","trailing":"Tabs_trailing__CU405"};